import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';




const isAbsoluteUrl = (url) => /^(?:https?:)?\/\//i.test(url);

const Photo = ({ src, alt, className, apiUrl, ...props }) => {
  const [blobUrl, setBlobUrl] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!src) {
      
      setBlobUrl('');
      return;
    }

    
    if (src.startsWith('data:image')) {
      setBlobUrl(src);
      return;
    }

    
    let finalUrl = src;
    if (!isAbsoluteUrl(src) && apiUrl) {
      
      const trimmed = src.replace(/^\/+/, '');
      
      finalUrl = apiUrl.endsWith('/')
        ? apiUrl + trimmed
        : apiUrl + '/' + trimmed;
    }

    setIsLoading(true);
    const cancelSource = axios.CancelToken.source();

    axios
      .get(finalUrl, {
        responseType: 'blob',
        cancelToken: cancelSource.token,
      })
      .then((res) => {
        setBlobUrl(URL.createObjectURL(res.data));
      })
      .catch((err) => {
        if (!axios.isCancel(err)) {
          console.error('Ошибка загрузки изображения:', err);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });

    
    return () => {
      cancelSource.cancel('Unmounted Photo');
    };
  }, [src, apiUrl]);

  if (!src || (!blobUrl && !isLoading)) {
    
    return (
      <img
        src="/templates/placeholder.webp"
        alt={alt}
        className={className}
        {...props}
      />
    );
  }

  if (isLoading && !blobUrl) {
    
    return (
      <div style={{ width: 60, height: 60, background: '#ccc' }}>
        Загрузка...
      </div>
    );
  }

  
  return (
    <img
      src={blobUrl}
      alt={alt}
      className={className}
      {...props}
    />
  );
};

Photo.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string.isRequired,
  className: PropTypes.string,
  
  apiUrl: PropTypes.string,
};

Photo.defaultProps = {
  src: '',
  className: '',
  apiUrl: '',
};

export default Photo;
